import { Annotation } from '../components/annotation/annotation';

export function getDocumentAnnotationColor(annotationType: Annotation['type']) {
	switch (annotationType) {
		case 'manuscript':
			return { background: '#F1F6FC', border: '#458EF3' };
		case 'text':
			return { background: '#F6F3FB', border: '#C4AEF2' };
		case 'date':
			return { background: '#E9FAF9', border: '#A7ECE7' };
		case 'full_name':
			return { background: '#FCEAEA', border: '#F4ACAB' };
		case 'initials':
			return { background: '#FBF1D9', border: '#F2CF7A' };
	}
}
